import { useForm } from "react-hook-form";
import { MEASUREMENT_TYPES } from "../../../../../../config/enums/MeasurementTypes";

export function usePackagingLevelForm() {
  const form = useForm({
    mode: "all",
    defaultValues: {
      materialWeightUnit: String(MEASUREMENT_TYPES.WEIGHT_KG),
      unitSizeWeightUnit: String(MEASUREMENT_TYPES.WEIGHT_KG)
    }
  });
  return { form };
}
